module.exports = __webpack_public_path__ + "img/designers-on-the-rise.10c566a1.png";